import React, { type JSX } from "react"

export interface HeaderStylesProps extends React.HTMLAttributes<HTMLElement> {
    type:
        | "displayTrim"
        | "displayTrade"
        | "h1"
        | "h2"
        | "accordionHeading"
        | "bigLinks"
        | "componentHeading"
        | "displayTradeH1"
    /** Semantic tag. `type` is the visual style only. */
    as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6"
    children: React.ReactNode
}

const textStyleMap = {
    displayTrim:
        "font-trimLightNew md:text-96 text-48 font-300 leading-90 md:tracking-[-5.7px] tracking-[-2.24px] uppercase",

    displayTrade:
        "font-tradeCondensedNew md:text-96 text-48 font-700 leading-90 md:tracking-[-3.8px] tracking-[-3.24px] uppercase",

    displayTradeH1:
        "font-tradeCondensedNew md:text-96 text-48 font-700 leading-90 md:tracking-[-3.8px] tracking-[-3.24px] uppercase",

    h1: "font-trimLightNew uppercase md:text-48 text-32 font-300 leading-110 tracking-[-2.4px] md:tracking-[-1.3px]",

    h2: "font-trimLightNew uppercase md:text-32 text-24 md:text-[32px] font-300 leading-[120%] tracking-[-1px] md:tracking-[-1.6px]",

    bigLinks:
        "font-trimLightNew md:text-96 text-48 font-300 leading-90 md:tracking-[-5.7px] tracking-[-2.24px] uppercase",

    accordionHeading:
        "font-trimLightNew uppercase md:text-48 text-32 font-300 leading-110 tracking-[-2.4px] md:tracking-[-1.3px]",

    componentHeading:
        "font-trimLightNew uppercase md:text-48 text-32 font-300 leading-110 tracking-[-2.4px] md:tracking-[-1.3px]"
}

const tagMap: Record<string, keyof JSX.IntrinsicElements> = {
    displayTrim: "h1",
    displayTrade: "h2",
    displayTradeH1: "h1",
    h1: "h1",
    h2: "h2",
    accordionHeading: "h2",
    bigLinks: "h3",
    componentHeading: "h2"
}

const Heading: React.FC<HeaderStylesProps> = ({
    type,
    as,
    children,
    className,
    ...props
}) => {
    const textStyle = `${textStyleMap[type]} ${className || ""}`
    const HeadingTag = as ?? tagMap[type] ?? "div"

    return React.createElement(HeadingTag, { className: textStyle, ...props }, children)
}

export default Heading
